/**
 * Cargo do responsável pela conta PJ — lista fechada desde out/2026
 * (`utils/jobTitles`, decisão do Bruno; era texto livre). Usado no cadastro,
 * em /atualizar-dados, no perfil, no cadastro por convite e no "Novo cliente"
 * do admin. Conta antiga com outro texto: o valor atual continua como opção
 * para não sumir ao abrir o perfil.
 */
import React from 'react';

import { Select } from 'ui';
import { JOB_TITLES } from 'utils/jobTitles';

interface Props {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  name?: string;
}

export const JobTitleSelect = ({
  value,
  onChange,
  id = 'role',
  name = 'role',
}: Props) => {
  const legacy =
    value && !(JOB_TITLES as readonly string[]).includes(value) ? value : null;

  return (
    <Select
      id={id}
      name={name}
      value={value}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
        onChange(e.target.value)
      }
    >
      <option value="">Selecione</option>
      {legacy && <option value={legacy}>{legacy}</option>}
      {JOB_TITLES.map((title) => (
        <option key={title} value={title}>
          {title}
        </option>
      ))}
    </Select>
  );
};
